"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  height: 85vh;\n  align-items: center;\n  justify-content: center;\n"])));
var Spinner = function Spinner(_ref) {
  var spinnerTxt = _ref.spinnerTxt;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Loader, {
    dataAttributes: {
      'data-testid': 'addonDetails-spinner'
    },
    appearance: "primary",
    text: spinnerTxt,
    srText: spinnerTxt
  }));
};
Spinner.propTypes = {
  spinnerTxt: _propTypes.default.string
};
var _default = Spinner;
exports.default = _default;